<template>
  <el-menu
    class="el-menu-vertical-demo"
    style="min-height: 800px;text-align: left"
    router
    :default-openeds="default_open"
  >
    <template v-if="$store.getters.getStorage.user.user.roles == 0">
      <el-submenu index="0">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span>数据维护</span>
        </template>
        <el-menu-item-group index="0-1">
          <el-menu-item index="/inspectDraw/report"
            ><i class="el-icon-tickets"></i
            ><span slot="title">报表中心</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/reportInfo"
            ><i class="el-icon-tickets"></i
            ><span slot="title">报表查看</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/comment"
            ><i class="el-icon-tickets"></i
            ><span slot="title">评论管理</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/taskMaintenance"
            ><i class="el-icon-tickets"></i
            ><span slot="title">任务查询</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/select"
            ><i class="el-icon-tickets"></i
            ><span slot="title">遴选系统</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/taskRevert"
            ><i class="el-icon-tickets"></i
            ><span slot="title">退件审核</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/userMaintenance"
            ><i class="el-icon-tickets"></i
            ><span slot="title">用户管理</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/regionInfo"
            ><i class="el-icon-tickets"></i
            ><span slot="title">区域管理</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/administration"
            ><i class="el-icon-tickets"></i
            ><span slot="title">行政管理</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/customerInfoList"
            ><i class="el-icon-tickets"></i
            ><span slot="title">审查机构管理</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/configList"
            ><i class="el-icon-tickets"></i
            ><span slot="title">配置管理</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/formConfig/list"
            ><i class="el-icon-tickets"></i
            ><span slot="title">表单配置</span></el-menu-item
          >
          <!-- <el-menu-item index="/inspectDraw/supervise_compact"><i class="el-icon-tickets"></i><span slot="title">合同管理</span></el-menu-item> -->
          <el-menu-item index="/inspectDraw/infoCharge"
            ><i class="el-icon-tickets"></i
            ><span slot="title">收费方式</span></el-menu-item
          >

          <el-menu-item index="/inspectDraw/drawManage"
            ><i class="el-icon-tickets"></i
            ><span slot="title">图库管理</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/drawMessage"
            ><i class="el-icon-tickets"></i
            ><span slot="title">短信模板</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/spotCheck"
            ><i class="el-icon-tickets"></i
            ><span slot="title">项目抽查</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/restPassword"
            ><i class="el-icon-tickets"></i
            ><span slot="title">修改密码</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/drawNotice"
            ><i class="el-icon-tickets"></i
            ><span slot="title">公告管理</span></el-menu-item
          >
          <!--<el-menu-item index="/inspectDraw/statement/project" >&lt;!&ndash;<i class="el-icon-tickets"></i>&ndash;&gt;<span slot="title">项目情况</span></el-menu-item>
            <el-menu-item index="/inspectDraw/common/signature" >&lt;!&ndash;<i class="el-icon-tickets"></i>&ndash;&gt;<span slot="title">签章测试</span></el-menu-item>-->
        </el-menu-item-group>
      </el-submenu>
    </template>
    <template v-else-if="$store.getters.getStorage.user.user.roles == 1">
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-tem-renwu"></i>
          <span>审图业务</span>
        </template>
        <el-menu-item-group index="1-1">
          <el-menu-item
            index="/inspectDraw/reportExamine"
            v-if="this.$store.getters.getStorage.city != 'wh'"
            ><i class="el-icon-tickets"></i
            ><span slot="title">接审审查</span></el-menu-item
          >
          <!-- <el-menu-item index="/inspectDraw/taskReply"><i class="el-icon-tickets"></i><span slot="title">回复审查</span></el-menu-item> -->
          <el-menu-item index="/inspectDraw/taskQueryList"
            ><i class="el-icon-tickets"></i
            ><span slot="title">项目查询</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/projectChange/affirm"
            ><i class="el-icon-tickets"></i
            ><span slot="title">变更确认</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/restPassword"
            ><i class="el-icon-tickets"></i
            ><span slot="title">修改密码</span></el-menu-item
          >
          <!-- <el-menu-item index="/inspectDraw/taskStatisticsList" ><i class="el-icon-tickets"></i><span slot="title">任务统计</span></el-menu-item> -->
          <!-- <el-menu-item index="/inspectDraw/signature" ><i class="el-icon-tickets"></i><span slot="title">合同管理</span></el-menu-item> -->
          <!-- <el-menu-item index="/inspectDraw/drawTaskContract"><i class="el-icon-tickets"></i><span slot="title">合同查询统计</span></el-menu-item> -->
          <!-- <el-menu-item index="/inspectDraw/drawContractTemplate"><i class="el-icon-tickets"></i><span slot="title">合同模板管理</span></el-menu-item> -->
        </el-menu-item-group>
      </el-submenu>
      <!-- <el-submenu index="2" >
            <template slot="title">
              <i class="el-icon-tem-renwu"></i>
              <span>数据维护</span>
            </template>
            <el-menu-item-group index="2-1"> -->
      <!--<el-menu-item index="/inspectDraw/drawConfig">&lt;!&ndash;<i class="el-icon-tickets"></i>&ndash;&gt;<span slot="title">配置管理</span></el-menu-item>-->
      <!--<el-menu-item index="/inspectDraw/drawProfessional" >&lt;!&ndash;<i class="el-icon-tickets"></i>&ndash;&gt;<span slot="title">专业配置</span></el-menu-item>-->
      <!--<el-menu-item index="/inspectDraw/drawNotice" >&lt;!&ndash;<i class="el-icon-tickets"></i>&ndash;&gt;<span slot="title">公告管理</span></el-menu-item>-->
      <!--<el-menu-item index="/inspectDraw/drawDesignList">&lt;!&ndash;<i class="el-icon-tickets"></i>&ndash;&gt;<span slot="title">设计单位审核</span></el-menu-item>-->
      <!-- <el-menu-item index="/inspectDraw/infoCharge" ><i class="el-icon-tickets"></i><span slot="title">收费方式</span></el-menu-item>
            </el-menu-item-group>
          </el-submenu> -->
    </template>
    <template v-else-if="$store.getters.getStorage.user.user.roles == 2">
      <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-tem-renwu"></i>
          <span>数据维护</span>
        </template>
        <el-menu-item-group index="3-1">
          <!--<el-menu-item index="/inspectDraw/report" >报表中心</el-menu-item>
            <el-menu-item index="/inspectDraw/administration" >行政管理</el-menu-item>
            <el-menu-item index="/inspectDraw/customerInfoList" >单位管理</el-menu-item>
            <el-menu-item index="/inspectDraw/regionInfo" >区域管理</el-menu-item>-->
          <el-menu-item index="/inspectDraw/staffManager"
            ><i class="el-icon-tickets"></i
            ><span slot="title">用户管理</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/userManager"
            ><i class="el-icon-tickets"></i
            ><span slot="title">员工管理</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/expertManager"
            ><i class="el-icon-tickets"></i
            ><span slot="title">审图专家</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/customerInfo"
            ><i class="el-icon-tickets"></i
            ><span slot="title">单位信息</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/customerEdit"
            ><i class="el-icon-tickets"></i
            ><span slot="title">单位信息维护</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/customerIcon"
            ><i class="el-icon-tickets"></i
            ><span slot="title">单位图标管理</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/restPassword"
            ><i class="el-icon-tickets"></i
            ><span slot="title">修改密码</span></el-menu-item
          >
        </el-menu-item-group>
      </el-submenu>
    </template>
    <!--领导-->
    <template v-else-if="$store.getters.getStorage.user.user.roles == 3">
      <el-submenu index="3">
        <template slot="title">
          <i class="el-icon-tem-renwu"></i>
          <span>审图业务</span>
        </template>
        <el-menu-item-group index="4-1">
          <el-menu-item index="/inspectDraw/taskQuery"
            ><i class="el-icon-tickets"></i
            ><span slot="title">任务查询</span></el-menu-item
          >
          <template
            v-if="
              $store.getters.getStorage.user.user.employeeRoles.indexOf(
                '领导'
              ) > -1
            "
          >
            <el-menu-item index="/inspectDraw/taskExamine"
              ><i class="el-icon-tickets"></i
              ><span slot="title">任务审批</span></el-menu-item
            >
               <el-menu-item index="/inspectDraw/sgtPush"
            ><i class="el-icon-tickets"></i
            ><span slot="title">数据推送</span></el-menu-item
          >
          </template>
          <template
            v-if="
              $store.getters.getStorage.user.user.employeeRoles.indexOf(
                '领导'
              ) > -1 ||
                $store.getters.getStorage.user.user.employeeRoles.indexOf(
                  '项目负责人'
                ) > -1
            "
          >
            <el-menu-item index="/inspectDraw/taskRecheck"
              ><i class="el-icon-tickets"></i
              ><span slot="title">任务复审</span></el-menu-item
            >
            <el-menu-item index="/inspectDraw/exportStatus"
              ><i class="el-icon-tickets"></i
              ><span slot="title">专家审图状态</span></el-menu-item
            >
            <el-menu-item index="/inspectDraw/taskMaintain"
              ><i class="el-icon-tickets"></i
              ><span slot="title">任务维护</span></el-menu-item
            >
            <el-menu-item index="/inspectDraw/taskPaused"
              ><i class="el-icon-tickets"></i
              ><span slot="title">任务还原</span></el-menu-item
            >
            <el-menu-item index="/inspectDraw/reportInfo"
              ><i class="el-icon-tickets"></i
              ><span slot="title">报表查看</span></el-menu-item
            >
            <el-menu-item index="/inspectDraw/reportForms"
              ><i class="el-icon-tickets"></i
              ><span slot="title">报表统计</span></el-menu-item
            >
            <el-menu-item index="/inspectDraw/drawManage"
              ><i class="el-icon-tickets"></i
              ><span slot="title">图库管理</span></el-menu-item
            >
          </template>
          <template
            v-if="
              $store.getters.getStorage.user.user.employeeRoles.indexOf(
                '领导'
              ) > -1 ||
                $store.getters.getStorage.user.user.employeeRoles.indexOf(
                  '盖章员'
                ) > -1
            "
          >
            <el-menu-item index="/inspectDraw/drawingSignature"
              ><i class="el-icon-tickets"></i
              ><span slot="title">图纸签章</span></el-menu-item
            >
            <el-menu-item index="/inspectDraw/taskCertification"
              ><i class="el-icon-tickets"></i
              ><span slot="title">任务颁证</span></el-menu-item
            >
          </template>
          <template
            v-if="
              $store.getters.getStorage.user.user.employeeRoles.indexOf(
                '财务'
              ) > -1
            "
          >
            <el-menu-item index="/inspectDraw/taskCharge"
              ><i class="el-icon-tickets"></i
              ><span slot="title">任务收费</span></el-menu-item
            >
            <el-menu-item index="/inspectDraw/taskCheck"
              ><i class="el-icon-tickets"></i
              ><span slot="title">收费复核</span></el-menu-item
            >
          </template>
          <template
            v-if="
              $store.getters.getStorage.user.user.employeeRoles.indexOf(
                '项目负责人'
              ) > -1
            "
          >
            <el-menu-item index="/inspectDraw/expertOpinion"
              ><i class="el-icon-tickets"></i
              ><span slot="title">意见汇总</span></el-menu-item
            >
            <el-menu-item index="/inspectDraw/taskNewTask"
              ><i class="el-icon-tickets"></i
              ><span slot="title">新任务</span></el-menu-item
            >
            <el-menu-item index="/inspectDraw/taskComputed"
              ><i class="el-icon-tickets"></i
              ><span slot="title">收费计算</span></el-menu-item
            >
          </template>
          <template
            v-if="
              $store.getters.getStorage.user.user.employeeRoles.indexOf(
                '领导'
              ) > -1
            "
          >
            <el-menu-item index="/inspectDraw/taskComputed"
              ><i class="el-icon-tickets"></i
              ><span slot="title">收费计算</span></el-menu-item
            >
          </template>
          <el-menu-item index="/inspectDraw/restPassword"
            ><i class="el-icon-tickets"></i
            ><span slot="title">修改密码</span></el-menu-item
          >
       
          <el-menu-item index="/inspectDraw/project_startstop"
            ><i class="el-icon-tickets"></i
            ><span slot="title">工改启停</span></el-menu-item
          >
        </el-menu-item-group>
      </el-submenu>
      <template
        v-if="
          $store.getters.getStorage.user.user.employeeRoles.indexOf('领导') >
            -1 ||
            $store.getters.getStorage.user.user.employeeRoles.indexOf(
              '项目负责人'
            ) > -1
        "
      >
        <el-submenu index="4">
          <template slot="title">
            <i class="el-icon-tem-data"></i>
            <span>数据维护</span>
          </template>
          <el-menu-item-group>
            <!--<el-menu-item index="/inspectDraw/taskComputed" ><i class="el-icon-tickets"></i><span slot="title">收费计算</span></el-menu-item>-->
            <el-menu-item index="/inspectDraw/infoExpert"
              ><i class="el-icon-tickets"></i
              ><span slot="title">专家费用公式</span></el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
      </template>
    </template>
    <!--领导-->
    <template v-else-if="$store.getters.getStorage.user.user.roles == 4">
      <el-submenu index="4" default-openeds>
        <template slot="title">
          <i class="el-icon-tem-111"></i>
          <span>专家业务</span>
        </template>
        <el-menu-item-group index="5-1">
          <el-menu-item index="/inspectDraw/expertQuery"
            ><i class="el-icon-tickets"></i
            ><span slot="title">待审任务</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/expertExamine"
            ><i class="el-icon-tickets"></i
            ><span slot="title">复审任务</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/expertSystem"
            ><i class="el-icon-tickets"></i
            ><span slot="title">任务查询</span></el-menu-item
          >
          <!-- <el-menu-item index="/inspectDraw/expertOpinion" ><i class="el-icon-tickets"></i><span slot="title">意见汇总</span></el-menu-item> -->
          <el-menu-item index="/inspectDraw/restPassword"
            ><i class="el-icon-tickets"></i
            ><span slot="title">修改密码</span></el-menu-item
          >
        </el-menu-item-group>
      </el-submenu>
    </template>
    <template v-if="$store.getters.getStorage.user.user.roles == 5">
      <el-submenu index="0">
        <template slot="title">
          <i class="el-icon-tem-renwu"></i>
          <span>数据维护</span>
        </template>
        <!-- <el-menu-item-group index="0-1">
          <el-menu-item index="/inspectSupervise/reportInfo"
            ><i class="el-icon-tickets"></i
            ><span slot="title">报表查看</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/comment"
            ><i class="el-icon-tickets"></i
            ><span slot="title">评论管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/taskMaintenance"
            ><i class="el-icon-tickets"></i
            ><span slot="title">任务查询</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/drawManage"
            ><i class="el-icon-tickets"></i
            ><span slot="title">图库管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/customerInfoList"
            ><i class="el-icon-tickets"></i
            ><span slot="title">单位管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/drawMessage"
            ><i class="el-icon-tickets"></i
            ><span slot="title">短信模板</span></el-menu-item
          >
          <el-menu-item index="/inspectDraw/restPassword"
            ><i class="el-icon-tickets"></i
            ><span slot="title">修改密码</span></el-menu-item
          >
        </el-menu-item-group> -->
        <el-menu-item-group index="0-1">
          <el-menu-item index="/inspectSupervise/comment"
            ><i class="el-icon-tickets"></i
            ><span slot="title">评论管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/taskMaintenance"
            ><i class="el-icon-tickets"></i
            ><span slot="title">任务查询</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/systemaudit"
            ><i class="el-icon-tickets"></i
            ><span slot="title">系统审计</span></el-menu-item
          >
          <!-- <el-menu-item index="/inspectSupervise/greenList"
            ><i class="el-icon-tickets"></i
            ><span slot="title">绿建报告</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/reportInfo"
            ><i class="el-icon-tickets"></i
            ><span slot="title">报表查看</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/tablearea"
            ><i class="el-icon-tickets"></i
            ><span slot="title">统计报表</span></el-menu-item
          > -->
          <el-menu-item index="/inspectSupervise/drawManage"
            ><i class="el-icon-tickets"></i
            ><span slot="title">图库管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/customerInfoList"
            ><i class="el-icon-tickets"></i
            ><span slot="title">单位管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/drawMessage"
            ><i class="el-icon-tickets"></i
            ><span slot="title">短信模板</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/drawConfig"
            ><i class="el-icon-tickets"></i
            ><span slot="title">配置管理</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/drawProfessional"
            ><i class="el-icon-tickets"></i
            ><span slot="title">专业配置</span></el-menu-item
          >
          <!-- <el-menu-item index="/inspectSupervise/supervise_compact"><i class="el-icon-tickets"></i><span slot="title">合同管理</span></el-menu-item> -->
          <el-menu-item index="/inspectSupervise/drawDesignList"
            ><i class="el-icon-tickets"></i
            ><span slot="title">设计单位审核</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/infoConstruction"
            ><i class="el-icon-tickets"></i
            ><span slot="title">建设单位</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/infoDesign"
            ><i class="el-icon-tickets"></i
            ><span slot="title">勘察设计单位</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/infoItemtype"
            ><i class="el-icon-tickets"></i
            ><span slot="title">项目类型</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/infoPolicy"
            ><i class="el-icon-tickets"></i
            ><span slot="title">政策材料</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/infoStrong"
            ><i class="el-icon-tickets"></i
            ><span slot="title">强标强条类型</span></el-menu-item
          >
          <el-menu-item index="/inspectSupervise/restPassword"
            ><i class="el-icon-tickets"></i
            ><span slot="title">修改密码</span></el-menu-item
          >
          <!-- <el-menu-item index="/inspectSupervise/drawNotice" ><i class="el-icon-tickets"></i><span slot="title">公告管理</span></el-menu-item> -->
        </el-menu-item-group>
      </el-submenu>
    </template>
    <template v-if="$store.getters.getStorage.user.user.roles == 6">
      <el-menu-item index="/inspectSupervise/taskMaintenance"
        ><i class="el-icon-tickets"></i
        ><span slot="title">任务查询</span></el-menu-item
      >
    </template>
  </el-menu>
</template>
<script>
export default {
  data() {
    return {
      route_active: "",
      default_open: []
    };
  },
  mounted() {
    //初始化
    switch (this.$store.getters.getStorage.user.user.roles) {
      case "1":
        this.default_open = ["1", "2"];
        break;
      case "2":
        this.default_open = ["2"];
        break;
      case "3":
        this.default_open = ["3"];
        break;
      case "4":
        this.default_open = ["4"];
    }
  },
  methods: {},
  watch: {
    $route(to, from) {
      this.route_active = this.$route.fullPath;
    }
  }
};
</script>
<style scoped="">
/*.el-scrollbar__wrap {
       overflow-x: hidden;
  }*/
</style>



// WEBPACK FOOTER //
// src/components/InspectDrawLeft.vue